module.exports = __webpack_public_path__ + "static/img/funny_02.bd65277e.jpg";